import { Calendar, CalendarDays, TrendingUp, Users } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/common/ui/card";
import { Skeleton } from "@/common/ui/skeleton";

import type { WaitlistStats } from "./types";

interface StatsCardsProps {
  stats: WaitlistStats | null;
  isLoading: boolean;
}

interface StatCardConfig {
  title: string;
  key: keyof WaitlistStats;
  icon: React.ReactNode;
}

const STAT_CARDS: StatCardConfig[] = [
  {
    title: "Total Signups",
    key: "total",
    icon: <Users className="h-4 w-4 text-muted-foreground" />,
  },
  { title: "Today", key: "today", icon: <TrendingUp className="h-4 w-4 text-muted-foreground" /> },
  {
    title: "This Week",
    key: "this_week",
    icon: <Calendar className="h-4 w-4 text-muted-foreground" />,
  },
  {
    title: "This Month",
    key: "this_month",
    icon: <CalendarDays className="h-4 w-4 text-muted-foreground" />,
  },
];

export function StatsCards({ stats, isLoading }: StatsCardsProps): React.ReactElement {
  return (
    <div data-testid="stats-cards" className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {STAT_CARDS.map((card) => (
        <Card key={card.key}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{card.title}</CardTitle>
            {card.icon}
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <Skeleton data-testid={`stat-skeleton-${card.key}`} className="h-8 w-20" />
            ) : (
              <div data-testid={`stat-${card.key}`} className="text-2xl font-bold">
                {stats?.[card.key]?.toLocaleString() ?? "—"}
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
